export default "__VITE_ASSET__kg9aA3sw__"